import { Form, Modal, Select, Switch, Tooltip } from "antd";
import { PreTableParams } from "../lib/types.ts";
import { exportSelect } from "../config/data.tsx";
import { useState } from "react";
import { usePostHog } from "posthog-js/react";
import { handleExcel, handleExport } from "./ExportHandlers.ts";
import { BsDownload } from "react-icons/bs";


const PreTable = (props: PreTableParams) => {

  const [value,setValue] = useState<string | null>(null)
  const posthog = usePostHog();
  const [exportFormat, setExportFormat] = useState<'csv' | 'xlsx' | undefined>(undefined)
  const [exportModalVisible, setExportModalVisible] = useState<boolean>(false)
  const [exportModalLoading, setExportModalLoading] = useState<boolean>(false)
  const [exportInMultipleRows, setExportInMultipleRows] = useState<boolean>(false)
  const [exportKeepCompanyData, setExportKeepCompanyData] = useState<boolean>(true)

  const handleChange = () => {
    exportFormat ? exportFormat === 'csv' ? 
      handleExport({
        id: props.id,
        data: "",
        hora: "",
        qtd_leads_solicitada: "",
        qtd_leads_gerada: "",
        status: "",
        path: ""
      },setExportModalLoading,exportInMultipleRows,exportKeepCompanyData,()=>{return},setExportModalVisible,setExportFormat,props.dataSource.map(lead=>{
        lead['dados_pessoas'] = typeof(lead['dados_pessoas']) === 'string' ? JSON.stringify(JSON.parse(lead['dados_pessoas'].replaceAll('""','"'))) : JSON.stringify(lead['dados_pessoas'])
        return lead
        })) 
      : 
      handleExcel({
        id: props.id,
        data: "",
        hora: "",
        qtd_leads_solicitada: "",
        qtd_leads_gerada: "",
        status: "",
        path: ""
      },setExportModalLoading,exportInMultipleRows,exportKeepCompanyData,()=>{return},setExportModalVisible,setExportFormat,props.dataSource.map(lead=>{
        lead['dados_pessoas'] = typeof(lead['dados_pessoas']) === 'string' ? JSON.stringify(JSON.parse(lead['dados_pessoas'].replaceAll('""','"'))) : JSON.stringify(lead['dados_pessoas'])
          return lead
        })) 
      : 
      setExportModalVisible(false)
  };

  return (
    <div className="pretable">
      <div>
        <Select
          className="preTableSelect"
          value={value}
          prefix={<BsDownload style={{ color: '#141774' }} />}
          allowClear
          dropdownStyle={{width: '12.5vh'}}
          onChange={(e: 'csv' | 'xlsx' | undefined) => {
            posthog.capture('export_dados_select');
            setExportFormat(e)
            setExportModalVisible(true)
            setValue(null)
          }}
          options={exportSelect}
        />
      </div>
      <Modal
        wrapClassName="exportModalWrapper"
        className="exportModal"
        title={<span style={{color: '#141774'}}>{`Exportar .${exportFormat}`}</span>}
        visible={exportModalVisible}
        onOk={()=>{exportFormat ? handleChange(): setExportModalVisible(false)}}
        onCancel={() => setExportModalVisible(false)}
        okText="Exportar"
        okButtonProps={{ loading: exportModalLoading, className: 'submitButton' }}
        
        cancelText="Cancelar"
        cancelButtonProps={{style: {display: 'none'}}}

      >
      <Form layout="vertical">
        <Form.Item>
          <div style={{ display: 'flex',alignItems: 'center' }}>
            <label style={{fontWeight:'normal'}}>Um funcionário por linha:</label>
            <Switch style={{marginLeft:'2em'}} checked={exportInMultipleRows} onChange={(e)=>{setExportInMultipleRows(e); if(e)setExportKeepCompanyData(e)}}/>
          </div>
        </Form.Item>
        <Form.Item>
          <div style={{ display: 'flex',alignItems: 'center' }}>
            <label  style={{fontWeight:'normal'}}>Manter dados da empresa:</label>
            <Tooltip title={exportInMultipleRows ? '' : 'Só pode ser desativado quando um funcionário por linha'}>
              <Switch style={{marginLeft:'1.25em'}} checked={exportInMultipleRows ? exportKeepCompanyData : true} onChange={(e)=>{setExportKeepCompanyData(e)}} disabled={!exportInMultipleRows}/>
            </Tooltip>
          </div>
        </Form.Item>
      </Form>

      </Modal>
    </div>
  );
};

export default PreTable;
